import React, { useContext } from 'react';
import Slider from "react-slick";
import { CardContext } from '../../../store/CardContext';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

// Custom Previous Arrow
const CustomPrevArrow = ({ onClick }) => {
    return (
        <div
            className="custom-arrow custom-prev"
            onClick={onClick}
            style={{
                position: 'absolute',
                left: '15px',
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 2,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                borderRadius: '50%',
                padding: '6px',
                cursor: 'pointer',
            }}
        >
            <IoIosArrowBack size={30} color="#fff" />
        </div>
    );
};

// Custom Next Arrow
const CustomNextArrow = ({ onClick }) => {
    return (
        <div
            className="custom-arrow custom-next"
            onClick={onClick}
            style={{
                position: 'absolute',
                right: '15px',
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 2,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                borderRadius: '50%',
                padding: '6px',
                cursor: 'pointer',
            }}
        >
            <IoIosArrowForward size={30} color="#fff" />
        </div>
    );
};

function HighlightImage({ theme }) {
    const [cardData] = useContext(CardContext);

    // Prepare the images array from the card data and filter out any null or undefined values
    const images = [
        cardData?.highlightPhotos1,
        cardData?.highlightPhotos2,
        cardData?.highlightPhotos3,
        cardData?.highlightPhotos4,
        cardData?.highlightPhotos5,
        cardData?.highlightPhotos6,
        cardData?.highlightPhotos7,
        cardData?.highlightPhotos8,
    ].filter(Boolean);

    // Slick Slider settings
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
        adaptiveHeight: true, // Adjust the slider height based on the image
    };

    return (
        <div className="relative p-2 rounded-[8px]">
            {/* Check if there are images to display */}
            {images.length > 0 ? (
                <Slider {...settings}>
                    {images.map((src, index) => (
                        <div key={index} className="relative">
                            <img
                                className={`rounded-[8px] w-full object-cover ${theme ? 'rounded-xl' : ''}`}
                                src={src}
                                alt={`Highlight ${index + 1}`}
                                style={{ height: '250px', width: '100%' }} // Set consistent image height
                            />
                        </div>
                    ))}
                </Slider>
            ) : (
                <p>No highlights available.</p>
            )}
        </div>
    );
}

export default HighlightImage;
